import * as Immutable from 'immutable';
import {
    SELECT_PRODUCT_UPDATE_REQUESTED,
    SELECT_PRODUCT_UPDATE_COMPLETED,
    SELECT_PRODUCT_UPDATE_ERROR,
    SELECT_PRODUCT_RESET_REQUESTED,
    SELECT_PRODUCT_RESET_COMPLETED,
} from '../../actions/select-product/types';

const schema = {
    error: null,

    selectproductupdaterequested: false,
    selectproductupdatecompleted: false,
    //
    selectproductresetrequested: false,
    selectproductresetcompleted: false,
    //
    selectproduct: {},
};

const initialState = Immutable.Map(schema);

const selectproductReducer = (state = initialState, action) => {
    switch (action.type) {
    case SELECT_PRODUCT_UPDATE_REQUESTED:
        return state
            .set('selectproductupdaterequested', true);

    case SELECT_PRODUCT_UPDATE_COMPLETED:
        return state
            .set('selectproductupdatecompleted', true)
            .set('selectproduct', action.payload);

    case SELECT_PRODUCT_UPDATE_ERROR:
        return state
            .set('selectproductupdaterequested', false)
            .set('error', action.payload);

    case SELECT_PRODUCT_RESET_REQUESTED:
        return state
            .set('selectproductresetrequested', true);

    case SELECT_PRODUCT_RESET_COMPLETED:
        return state
            .set('selectproductresetcompleted', true)
            .set('selectproduct', {});

    default:
        return state;
    }
};

export { initialState };

export default selectproductReducer;
